import glslCnoise from '@/libs/lygia/generative/cnoise.glsl';
import glslFBM from '@/libs/lygia/generative/fbm.glsl';

export const uniforms = () => ({
    u_shine_angle: { value: 0 },
    u_shine: { value: 0 },
});

export const shaderChunks = {
    uniforms: /* glsl */ `
        uniform float u_shine_angle;
        uniform float u_shine;
    `,

    funcs: /* glsl */ `
        ${glslCnoise}
        ${glslFBM}
        float applyShineEffect(float u_shineValue, vec3 meshPosition, float shineSizeTop, float shineSizeBottom,  float angle, float intensity) {
            float range = 0.85;
            // float shineInput = u_shineValue*range*(2.0+shineSizeBottom) + (meshPosition.y-meshPosition.x*angle + meshPosition.z * 5.0 - range);
            float shineInput = meshPosition.z + u_shineValue - meshPosition.y * .5 + meshPosition.x * angle;
            float shinePower = smoothstep(-shineSizeBottom, 0.0, shineInput) * smoothstep(shineSizeTop, 0.0, shineInput);
            return pow(shinePower * intensity, 3.0);
        }

        vec3 shineRGB(float u_shineValue, vec3 position, float shineSizeTop, float shineSizeBottom,  float angle, float intensity ){
            vec3 shineColorMul = vec3(0.0);
            shineColorMul.r =applyShineEffect(u_shineValue , position, shineSizeTop,        shineSizeBottom,  angle, 1.0);
            shineColorMul.g =applyShineEffect(u_shineValue  , position, shineSizeTop + 0.1, shineSizeBottom+0.1 ,  angle, 1.0);
            shineColorMul.b = applyShineEffect(u_shineValue,  position, shineSizeTop + 0.2,           shineSizeBottom +0.2,  angle, 1.0);
            return shineColorMul;
        }

        vec3 transition_shine(vec3 color, vec3 position, float progress, float angle, float zOffset) {
             // // Apply the shine effect
            vec3 shineColor = vec3(0.6, 0.6, 0.9);
            // vec3 shineColor = vec3(1.0, 1.0, 1.0);
            float shineMapped = progress * 3.0 - 1.0;
            float shineMin1 = 1.0 - progress;
            // float baseCol =  max(0.0, min(1.0, (progress - position.y + 0.7)));
            float gradY = (position.y + 0.7) + shineMapped;
            float gradRange = 0.5;
            float baseCol =  smoothstep( -gradRange, gradRange, gradY) * 1.0 + 0.;


            vec3 shineColorMul = vec3(0.0);
            // shine += applyShineEffect(shineMapped,     position, 0.8, 0.1,  0.2, 1.0 );
            float shineAngle = 0.0;//angle;

            float shineZ = -0.6 + zOffset;

            float n = 0.0;
            // remove cnoise for performance
            // float n = cnoise(position * 3.0) * .05;

            vec3 shine = pow(shineRGB(shineZ-0.4+n, position,  0.2, .7, shineAngle, 1.0), vec3(8.0, 4.0, 1.0));
            shine += pow(shineRGB(shineZ-0.8+n, position,  0.2, .2, shineAngle, 1.0), vec3(2.0, 3.0, 6.0))*.05;
            shine += pow(shineRGB(shineZ-1.2+n, position,  0.2, .2, shineAngle, 1.0), vec3(16.0, 10.0, 1.0))*0.05;
            // shine *= smoothstep(0.4, -0.1, position.x);
            color.rgb *= (1.0 - position.z) * .5  + .5;
            // color.rgb *= baseCol;
            float colorInfluence = 0.9;
            color.rgb += shine * 10.0* (pow(color, vec3(3.0))*.75*colorInfluence + vec3(1.0-colorInfluence));
            return color;
        }

        vec3 transition_shine(vec3 color, vec3 position, float progress, float angle) {
            return transition_shine(color, position, progress, angle, 0.0);
        }
    `,
};
